export default __webpack_public_path__ + "d60186a02a259cb8a097e925512cf20f.png";